<ls-modal
  data-nested-translation="browsercheck.modalWindow.title"
  [title]="'browsercheck.modalWindow.title' | translate | hideTranslation"
  [visible]="isBrowserModalOpened"
  [closable]="false"
  [footerContent]="false"
>
  <div class="flex justify-content-center gap-3 m-b-6">
    <a
      class="browser-icon flex flex-column justify-content-center align-items-center cursor-pointer border-round-md p-2 md:p-4"
      href="https://www.google.com/chrome/"
      target="_blank"
    >
      <h3 class="theme-heading">Chrome</h3>

      <img
        class="browser-icon-image max-w-full"
        src="../../assets/images/browsers/chrome.png"
        [alt]="'Google Chrome'"
      />
    </a>

    <a
      class="browser-icon flex flex-column justify-content-center align-items-center cursor-pointer border-round-md p-2 md:p-4"
      href="https://www.mozilla.org/en-US/firefox/new/"
      target="_blank"
    >
      <h3>Firefox</h3>

      <img
        class="browser-icon-image max-w-full"
        src="../../assets/images/browsers/firefox.png"
        [alt]="'Mozilla Firefox'"
      />
    </a>

    <a
      class="browser-icon flex flex-column justify-content-center align-items-center cursor-pointer border-round-md p-2 md:p-4"
      href="https://www.microsoft.com/en-us/edge"
      target="_blank"
    >
      <h3>Edge</h3>

      <img class="browser-icon-image max-w-full" src="../../assets/images/browsers/edge.png" [alt]="'Microsoft Edge'" />
    </a>

    <a
      class="browser-icon flex flex-column justify-content-center align-items-center cursor-pointer border-round-md p-2 md: p-2 md:p-4"
      href="https://support.apple.com/downloads/safari"
      target="_blank"
    >
      <h3>Safari</h3>

      <img
        class="browser-icon-image max-w-full"
        src="../../assets/images/browsers/safari.png"
        [alt]="'Safari Browser'"
      />
    </a>
  </div>

  <a class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="browsercheck.modalWindow.close"
      *ngIf="isBrowserModalCloseVisible"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'browsercheck.modalWindow.close' | translate | hideTranslation"
      (onClick)="closeModalWindow($event)"
    />
  </a>
</ls-modal>
